export function getStoredUser() {
  try {
    return JSON.parse(localStorage.getItem("ps_user") || "{}");
  } catch (error) {
    return {};
  }
}

export function hasRole(user, roles = []) {
  return roles.includes(user.role);
}

export function roleLabel(role) {
  if (role === "super_admin") return "超管";
  if (role === "admin") return "管理员";
  if (role === "sales") return "业务员";
  if (role === "courier") return "配送员";
  return role || "-";
}
